var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 144,
    viewBox: "0 0 105 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.4473 20.4828L9.79703 35.2797C4.8404 36.5302 1.81268 41.4696 3.03441 46.3122L25.3368 134.712C26.5585 139.554 31.567 142.466 36.5237 141.216L95.1739 126.419C100.131 125.168 103.158 120.229 101.937 115.386L79.6342 26.9868C78.4125 22.1442 73.4039 19.2323 68.4473 20.4828Z",
    fill: "#9C4C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3488 116.756L73.1851 28.9062C72.8334 27.5123 71.3898 26.6746 69.9607 27.0352L11.5745 41.7655C10.1453 42.126 9.27189 43.5483 9.62355 44.9422L31.7873 132.792C32.1389 134.186 33.5825 135.024 35.0117 134.663L93.3979 119.933C94.827 119.572 95.7005 118.15 95.3488 116.756Z",
    fill: "#FFE3E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1084 22.6522L30.4909 26.5923C28.9529 26.9804 28.0256 28.5613 28.4197 30.1235L30.2819 37.5046C30.676 39.0668 32.2423 40.0186 33.7803 39.6306L49.3978 35.6904C50.9358 35.3024 51.8632 33.7215 51.469 32.1593L49.6069 24.7782C49.2127 23.216 47.6464 22.2642 46.1084 22.6522Z",
    fill: "#C97878"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3004 11.9379L81.5449 2",
    stroke: "#9C4C4C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2945 19.3667L96.168 13.8394",
    stroke: "#9C4C4C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38 87.6418L51.6471 95L67 66",
    stroke: "#D38D8D",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinish);
export default __webpack_public_path__ + "static/media/finish.161b5553486574cba87cce79463cdc0f.svg";
export { ForwardRef as ReactComponent };